import { useEffect } from 'react';

import { getClassNameBySite } from '@panel/commons/helpers';

const useAppliedClassName = () => {
  useEffect(() => {
    const className = getClassNameBySite();

    document.documentElement.classList.add(className);
  }, []);
};

export { useAppliedClassName };
